<template>
    <div class="col-md-6">
        <label class="attribute-label m-bottom-12" :for="id">Discount Included</label>

        <div class="input-group width-100">
            <input type="text" class="form-control price-new-inputs" :id="id" :name="name" :value="discount.toFixed(2)" disabled>
            <input type="hidden" class="form-control price-new-inputs" id="total_discount" name="total_discount" v-model="discount.toFixed(2)">
            <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BookingDiscountIncludedField",
    props: ['discount','currency'],
    computed: {
        id() {
            return 'discount_included'
        },
        name() {
            return 'discount_included'
        }
    }
}
</script>

<style scoped>

</style>